var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBedRevenue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.21,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 30V40.8573C0 51.4295 8.57046 60 19.1427 60H30H40.8573C51.4295 60 60 51.4295 60 40.8573V30V19.1427C60 8.57046 51.4295 0 40.8573 0H30H19.1427C8.57046 0 0 8.57046 0 19.1427V30Z",
    fill: "#8280FF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4972_13063)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.7662 29.6211H15.8459V34.3547H44.7662V29.6211Z",
    fill: "#E1D4FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M44.7659 29.6211H42.849V34.3547H44.7659V29.6211Z",
    fill: "#6D48AA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.8461 29.6211V34.3547H26.7411C24.5309 32.9513 24.0565 30.9617 24.1982 29.6211H15.8461Z",
    fill: "#845EC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1396 35.6519C35.9015 35.6519 35.6863 35.4886 35.6309 35.2475L33.8601 27.5346C33.7959 27.2545 33.9717 26.9756 34.2529 26.9115C34.5342 26.8478 34.8142 27.0227 34.8784 27.3027L36.6492 35.0156C36.7135 35.2957 36.5377 35.5746 36.2565 35.6386C36.2173 35.6475 36.1781 35.6519 36.1396 35.6519Z",
    fill: "#845EC2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M36.1396 35.6519C35.9015 35.6519 35.6863 35.4886 35.6309 35.2475L33.8601 27.5346C33.7959 27.2545 33.9717 26.9756 34.2529 26.9115C34.5342 26.8478 34.8142 27.0227 34.8784 27.3027L36.6492 35.0156C36.7135 35.2957 36.5377 35.5746 36.2565 35.6386C36.2173 35.6475 36.1781 35.6519 36.1396 35.6519Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2918 35.4018C31.0574 35.4018 30.8442 35.2435 30.7853 35.0067L29.4518 29.6534C29.2787 28.9585 29.4334 28.2365 29.8763 27.6725C30.3192 27.1086 30.9855 26.7852 31.7044 26.7852H37.5921C38.5072 26.7852 39.3393 27.3231 39.7119 28.1556L40.4458 29.7953C40.9258 30.8678 41.1692 32.0069 41.1692 33.1811V34.8814C41.1692 35.1687 40.9354 35.4016 40.6469 35.4016C40.3584 35.4016 40.1246 35.1687 40.1246 34.8814V33.1811C40.1246 32.1538 39.9117 31.1572 39.4917 30.2189L38.7578 28.5792C38.5529 28.1213 38.0953 27.8255 37.5921 27.8255H31.7044C31.3091 27.8255 30.9426 28.0033 30.6991 28.3135C30.4555 28.6237 30.3704 29.0207 30.4656 29.4028L31.7992 34.7562C31.8686 35.035 31.698 35.3172 31.418 35.3863C31.3758 35.3967 31.3334 35.4018 31.2918 35.4018Z",
    fill: "#845EC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3828 28.1089H45.5164C45.102 28.1089 44.766 28.4435 44.766 28.8562V33.7698C44.766 34.0971 44.4995 34.3625 44.1708 34.3625H16.4412C16.1125 34.3625 15.846 34.0971 15.846 33.7698V24.8215C15.846 24.4088 15.5101 24.0742 15.0957 24.0742H13.2293C12.8149 24.0743 12.479 24.4089 12.479 24.8215V34.949C12.479 36.116 13.4288 37.062 14.6005 37.062H46.0116C47.1833 37.062 48.1331 36.116 48.1331 34.949V28.8563C48.1331 28.4435 47.7972 28.1089 47.3828 28.1089Z",
    fill: "#9A7BDE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9276 29.6632H18.8099C18.3451 29.6632 17.9146 29.4201 17.6758 29.0229L17.4599 28.6636C17.2727 28.3522 17.2727 27.9635 17.4599 27.652L17.6758 27.2927C17.9146 26.8955 18.3451 26.6523 18.8099 26.6523H23.9276C24.3923 26.6523 24.8229 26.8954 25.0616 27.2927L25.2776 27.652C25.4647 27.9634 25.4647 28.3522 25.2776 28.6636L25.0616 29.0229C24.8229 29.4201 24.3923 29.6632 23.9276 29.6632Z",
    fill: "#845EC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9182 40.5091H18.6939C18.4054 40.5091 18.1716 40.2762 18.1716 39.9889C18.1716 39.7017 18.4054 39.4688 18.6939 39.4688H41.9182C42.2067 39.4688 42.4405 39.7017 42.4405 39.9889C42.4405 40.2762 42.2067 40.5091 41.9182 40.5091Z",
    fill: "#38648C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6938 37.0586H16.8319V42.2478H18.6938V37.0586Z",
    fill: "#845EC2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M18.6938 37.0586H16.8319V38.7038H18.6938V37.0586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.763 45.3063C18.7577 45.3063 19.564 44.5032 19.564 43.5125C19.564 42.5219 18.7577 41.7188 17.763 41.7188C16.7683 41.7188 15.962 42.5219 15.962 43.5125C15.962 44.5032 16.7683 45.3063 17.763 45.3063Z",
    fill: "#495059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7629 44.037C18.0515 44.037 18.2855 43.804 18.2855 43.5166C18.2855 43.2291 18.0515 42.9961 17.7629 42.9961C17.4743 42.9961 17.2404 43.2291 17.2404 43.5166C17.2404 43.804 17.4743 44.037 17.7629 44.037Z",
    fill: "#845EC2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.7798 37.0586H41.918V42.2478H43.7798V37.0586Z",
    fill: "#845EC2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M43.7798 37.0586H41.918V38.7038H43.7798V37.0586Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8491 45.3063C43.8437 45.3063 44.6501 44.5032 44.6501 43.5125C44.6501 42.5219 43.8437 41.7188 42.8491 41.7188C41.8544 41.7188 41.048 42.5219 41.048 43.5125C41.048 44.5032 41.8544 45.3063 42.8491 45.3063Z",
    fill: "#495059"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.849 44.037C43.1376 44.037 43.3716 43.804 43.3716 43.5166C43.3716 43.2291 43.1376 42.9961 42.849 42.9961C42.5604 42.9961 42.3265 43.2291 42.3265 43.5166C42.3265 43.804 42.5604 44.037 42.849 44.037Z",
    fill: "#845EC2"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M25.0139 34.3625H16.4412C16.1125 34.3625 15.846 34.0971 15.846 33.7698V24.8215C15.846 24.4088 15.5101 24.0742 15.0957 24.0742H13.2293C12.8149 24.0743 12.479 24.4089 12.479 24.8215V34.949C12.479 36.116 13.4288 37.062 14.6005 37.062H27.6078C26.1071 36.3435 25.3486 35.2885 25.0139 34.3625Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M18.8099 26.6523C18.3451 26.6523 17.9146 26.8954 17.6758 27.2927L17.4599 27.652C17.2727 27.9634 17.2727 28.3522 17.4599 28.6636L17.6758 29.0229C17.9146 29.42 18.3451 29.6632 18.8099 29.6632H20.8426C19.5041 29.1216 19.434 27.4698 19.8227 26.6524L18.8099 26.6523Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3061 24.3222C32.8777 24.3222 34.9624 22.2458 34.9624 19.6845C34.9624 17.1232 32.8777 15.0469 30.3061 15.0469C27.7345 15.0469 25.6497 17.1232 25.6497 19.6845C25.6497 22.2458 27.7345 24.3222 30.3061 24.3222Z",
    fill: "#6927DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.2576 18.5542V17.1444C31.2576 17.015 31.1523 16.9102 31.0224 16.9102H29.5897C29.4598 16.9102 29.3544 17.015 29.3544 17.1444V18.5543C29.3544 18.6569 29.2709 18.7402 29.1677 18.7402H27.7522C27.6223 18.7402 27.517 18.8451 27.517 18.9745V20.4015C27.517 20.5309 27.6223 20.6358 27.7522 20.6358H29.1677C29.2709 20.6358 29.3544 20.719 29.3544 20.8217V22.2315C29.3544 22.3609 29.4597 22.4658 29.5897 22.4658H31.0224C31.1523 22.4658 31.2576 22.361 31.2576 22.2315V20.8217C31.2576 20.7191 31.3412 20.6358 31.4443 20.6358H32.8598C32.9897 20.6358 33.095 20.5309 33.095 20.4015V18.9744C33.095 18.845 32.9897 18.7402 32.8598 18.7402H31.4443C31.3412 18.7401 31.2576 18.6569 31.2576 18.5542Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4972_13063"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35.6542,
    height: 35.511,
    fill: "white",
    transform: "translate(12.479 12.4219)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBedRevenue);
export default __webpack_public_path__ + "static/media/bedRevenue.5c1791a23bdd1707f1513991bd8a06a8.svg";
export { ForwardRef as ReactComponent };